import { render, staticRenderFns } from "./PerformerActivitiesFilterTab.vue?vue&type=template&id=dca9607c&scoped=true&"
import script from "./PerformerActivitiesFilterTab.vue?vue&type=script&lang=js&"
export * from "./PerformerActivitiesFilterTab.vue?vue&type=script&lang=js&"
import style0 from "./PerformerActivitiesFilterTab.vue?vue&type=style&index=0&id=dca9607c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca9607c",
  null
  
)

export default component.exports